// pillow-engine.js — Recommendation logic derived from the Lagoon pillow-finder
// spreadsheet. Each pillow has 0–10 weights against the answer choices for six
// question dimensions: concern, position, temperature, body, density, height.
// We score by summing the weights for the user's selected answers, normalize,
// and surface the top match + runner-up + reasoning.

window.LAGOON_PILLOWS = [
  {
    id: 'chinchilla',
    name: 'The Chinchilla',
    tagline: 'Soft, low-loft, plush — like sinking into a cloud.',
    price: 139.99,
    url: 'https://lagoonsleep.com/products/the-chinchilla?variant=19927149838465',
    accent: '#C8B6A6',
    image: 'chinchilla',
    bestFor: ['Stomach sleepers', 'Slender builds', 'Soft feel lovers'],
    feel: 'Soft & airy · Low loft',
  },
  {
    id: 'puffin',
    name: 'The Puffin',
    tagline: 'Plush comfort with a touch of structure — versatile, balanced.',
    price: 139.99,
    url: 'https://lagoonsleep.com/products/the-puffin?variant=19927149641857',
    accent: '#B7C9C5',
    image: 'puffin',
    bestFor: ['Back sleepers', 'Cold sleepers', 'Plush + supportive'],
    feel: 'Cushy · Low–medium loft',
  },
  {
    id: 'fox',
    name: 'The Fox',
    tagline: 'Cradling memory foam — quiets tossing, holds your shape.',
    price: 139.99,
    url: 'https://lagoonsleep.com/products/the-fox?variant=19852946997377',
    accent: '#D69B6E',
    image: 'fox',
    bestFor: ['Combo sleepers', 'Neck pain', 'Toss & turn'],
    feel: 'Cushy & cradling · Medium loft',
  },
  {
    id: 'otter',
    name: 'The Otter',
    tagline: 'Cool, supportive, side-sleeper favorite — pressure relief built in.',
    price: 139.99,
    url: 'https://lagoonsleep.com/products/the-otter?variant=40312375541889',
    accent: '#7AAFB8',
    image: 'otter',
    bestFor: ['Side sleepers', 'Broad shoulders', 'Sleeps a little hot'],
    feel: 'Firm & supportive · Medium–high loft',
  },
  {
    // The Otter II — successor to the Otter. Same fit profile, new build.
    // Eligibility is controlled by the succession toggle in lagoon-quiz.js.
    id: 'otter2',
    name: 'The Otter II',
    tagline: 'Cool, supportive, side-sleeper favorite — pressure relief built in.',
    price: 159.99,   // King 179.99 — live prices come from the PDP fetch
    url: 'https://lagoonsleep.com/products/the-otter-ii-next-gen-cooling-and-supportive-versatile-pillow?variant=40785441685633',
    accent: '#7AAFB8',
    image: 'otter2',
    bestFor: ['Side sleepers', 'Broad shoulders', 'Sleeps a little hot'],
    feel: 'Firm & supportive · Medium–high loft',
  },
  {
    id: 'polarbear',
    name: 'The Polar Bear',
    tagline: 'Cooling adjustable fill — the iciest pillow Lagoon makes.',
    price: 199.99,
    url: 'https://lagoonsleep.com/products/the-polar-bear-reversible-adjustable-cooling-pillow-copy',
    accent: '#9EC6E0',
    image: 'polarbear',
    bestFor: ['Hot sleepers', 'Side sleepers', 'Adjustable loft'],
    feel: 'Firm & adjustable · Medium–high loft',
  },
];

// Weights extracted from the spreadsheet (Queen variant rows).
// Each cell is 0–10. Higher = better fit.
window.LAGOON_WEIGHTS = {
  //                concern: toss, neck, hot, snore, wrinkles, none
  //                position: side, back, stomach, combo
  //                temp: hot, neutral, cold
  //                body: slender, average, broad
  //                density: soft, cushy, firm, notsure   ("notsure" scores the same as cushy, the middle option)
  //                height: low, medium, high, notsure
  chinchilla: {
    concern:  { toss: 4,  neck: 6,  hot: 0,  snore: 0,  wrinkles: 10, none: 5 },
    position: { side: 2,  back: 3,  stomach: 10, combo: 2 },
    temp:     { hot: 0,   neutral: 5,  cold: 10 },
    body:     { slender: 10, average: 5,  broad: 0 },
    density:  { soft: 10, cushy: 3,  firm: 0,  notsure: 3 },
    height:   { low: 10,  medium: 2, high: 0, notsure: 5 },
  },
  puffin: {
    concern:  { toss: 6,  neck: 6,  hot: 0,  snore: 0,  wrinkles: 6,  none: 5 },
    position: { side: 4,  back: 10, stomach: 8,  combo: 4 },
    temp:     { hot: 0,   neutral: 5,  cold: 10 },
    body:     { slender: 7, average: 5, broad: 10 },
    density:  { soft: 9,  cushy: 4,  firm: 0,  notsure: 4 },
    height:   { low: 10,  medium: 6, high: 0, notsure: 5 },
  },
  fox: {
    concern:  { toss: 10, neck: 8,  hot: 0,  snore: 6,  wrinkles: 0,  none: 5 },
    position: { side: 6,  back: 10, stomach: 6,  combo: 10 },
    temp:     { hot: 0,   neutral: 5,  cold: 10 },
    body:     { slender: 5, average: 5, broad: 8 },
    density:  { soft: 5,  cushy: 10, firm: 5,  notsure: 10 },
    height:   { low: 5,   medium: 10, high: 6, notsure: 5 },
  },
  otter: {
    concern:  { toss: 8,  neck: 9,  hot: 8,  snore: 6,  wrinkles: 0,  none: 5 },
    position: { side: 10, back: 8,  stomach: 3,  combo: 10 },
    temp:     { hot: 9,   neutral: 5,  cold: 0 },
    body:     { slender: 5, average: 5, broad: 6 },   // was 10. Broad shoulders now favor the Polar Bear (Oct 2026)
    density:  { soft: 3,  cushy: 8,  firm: 8,  notsure: 8 },
    height:   { low: 5,   medium: 10, high: 8, notsure: 5 },
  },
  otter2: {
    concern:  { toss: 8,  neck: 9,  hot: 8,  snore: 6,  wrinkles: 0,  none: 5 },
    position: { side: 10, back: 8,  stomach: 3,  combo: 10 },
    temp:     { hot: 9,   neutral: 5,  cold: 0 },
    body:     { slender: 5, average: 5, broad: 6 },   // was 10. Broad shoulders now favor the Polar Bear (Oct 2026)
    density:  { soft: 3,  cushy: 8,  firm: 8,  notsure: 8 },
    height:   { low: 5,   medium: 10, high: 8, notsure: 5 },
  },
  polarbear: {
    concern:  { toss: 6,  neck: 8,  hot: 10, snore: 6,  wrinkles: 0,  none: 5 },
    position: { side: 10, back: 4,  stomach: 0,  combo: 6 },
    temp:     { hot: 10,  neutral: 5,  cold: 0 },
    body:     { slender: 5, average: 5, broad: 10 },
    density:  { soft: 0,  cushy: 5,  firm: 10, notsure: 5 },
    height:   { low: 2,   medium: 8, high: 10, notsure: 5 },
  },
};

// Question multipliers — match the post-3/20/26 production simulator weights.
// Position is the highest-information question, then density. Concerns/goals
// are small because product weights are nearly-neutral on them.
//
// Lagoon's own simulator already calibrates the output distribution toward
// the target mix — we DO NOT add an additional drift bonus on top. The
// engine here aligns to production, it doesn't second-guess it.
window.LAGOON_QUESTION_WEIGHTS = {
  position: 40,
  density:  20,
  body:     10,
  temp:      5,   // was 10. Halved Oct 2026: 63% of quiz takers answer "hot", so it was over-deciding the match
  height:   10,
  concern:   5,
  goals:     5,
};

// Reference only — used in the strategy artboard, not in scoring.
window.LAGOON_TARGET_MIX = {
  otter:      0,      // retired — replaced by the Otter II
  otter2:     0.50,   // inherits the Otter's share
  fox:        0.20,
  polarbear:  0.15,
  chinchilla: 0.09,
  puffin:     0.06,
};

// 30-day sales mix (Apr 16 – May 16 2026). Used as social proof in the rec
// card ("our #1 best-seller this month") and in the strategy artboard.
window.LAGOON_SALES_30D = {
  totals: {
    otter:      663,
    fox:        203,
    chinchilla: 109,
    polarbear:   90,
    puffin:       1,
  },
  shares: {
    otter:      0.622,
    fox:        0.190,
    chinchilla: 0.102,
    polarbear:  0.084,
    puffin:     0.001,
  },
  rank: ['otter', 'fox', 'chinchilla', 'polarbear', 'puffin'],
};
// The Otter II inherits the Otter's sales standing — it replaces the #1 seller,
// so social proof carries over rather than reading as a brand-new SKU with none.
window.LAGOON_SALES_30D.totals.otter2 = window.LAGOON_SALES_30D.totals.otter;
window.LAGOON_SALES_30D.shares.otter2 = window.LAGOON_SALES_30D.shares.otter;
window.LAGOON_SALES_30D.rank = window.LAGOON_SALES_30D.rank
  .map(function(id){ return id === 'otter' ? 'otter2' : id; });

// Score given an answers object: { concern, position, temp, body, density, height, goals?[] }
// Returns sorted pillows with normalized confidence (0–100).
// Applies misfit penalties learned from low-star reviews + returns.
window.scorePillows = function(answers) {
  const W = window.LAGOON_WEIGHTS;
  const QW = window.LAGOON_QUESTION_WEIGHTS;
  const dims = ['concern', 'position', 'temp', 'body', 'density', 'height'];
  const misfitFlags = window.LAGOON_MISFIT_FLAGS || {};
  const misfitCombos = window.LAGOON_MISFIT_COMBOS || [];

  const scored = window.LAGOON_PILLOWS.map(p => {
    let raw = 0;
    let max = 0;
    dims.forEach(d => {
      if (answers[d]) {
        const w = QW[d] || 1;
        raw += (W[p.id][d][answers[d]] || 0) * w;
        max += 10 * w;
      }
    });
    // Single-dim misfit penalties (scaled by that question's weight).
    const penalties = [];
    (misfitFlags[p.id] || []).forEach(f => {
      if (answers[f.dim] === f.value && f.penalty > 0) {
        const w = QW[f.dim] || 1;
        raw -= f.penalty * w;
        penalties.push(f.why);
      }
    });
    // Combo penalties (rules across two dims).
    misfitCombos.forEach(c => {
      if (c.pillow !== p.id) return;
      if (Object.entries(c.when).every(([k, v]) => answers[k] === v)) {
        raw -= c.penalty * 5;
        penalties.push(c.why);
      }
    });

    return { ...p, raw, max, penalties };
  });

  scored.sort((a, b) => b.raw - a.raw);
  // Confidence model:
  //  • Winner gets a VARIABLE score in 90–99, driven by how well it actually
  //    fits the answers (fit = raw/max) and how clearly it beat #2 (margin).
  //    A strong, unambiguous match → high 90s; a close/compromise pick → low 90s.
  //  • Everyone else scales down from the winner's raw for display only.
  const winner = scored[0];
  const topRaw = Math.max(1, winner.raw);
  const fit = winner.max > 0 ? Math.max(0, Math.min(1, winner.raw / winner.max)) : 0.7;
  const runnerRaw = scored[1] ? Math.max(0, scored[1].raw) : 0;
  const margin = Math.max(0, Math.min(1, (topRaw - runnerRaw) / topRaw)); // 0..1 separation
  const marginNorm = Math.min(1, margin / 0.30); // a 30% lead earns full margin credit
  scored.forEach((p, i) => {
    if (i === 0) {
      p.confidence = Math.max(90, Math.min(99, Math.round(90 + (0.55 * fit + 0.45 * marginNorm) * 9)));
    } else {
      p.confidence = Math.max(35, Math.round((Math.max(0, p.raw) / topRaw) * 82));
    }
  });
  return scored;
};

// Cross-sell logic — pulled from the top-selling accessories in the 30-day data.
// Returns 1 complementary product suggestion for a given pillow recommendation
// + answer profile.
// Pillowcase catalog with full benefit copy + per-pillow pairing logic.
//   Cooling Flex → Fox, Otter, Polar Bear (foam pillows + hot sleepers)
//   Silk Luxe    → Chinchilla, Puffin (stomach sleepers + skin/hair)
window.LAGOON_PILLOWCASES = {
  'cooling-pillowcase': {
    id: 'cooling-pillowcase',
    name: 'Cooling Flex Pillowcase',
    price: 89.99,
    url: 'https://lagoonsleep.com/products/cooling-flex-performance-pillowcase',
    benefits: [
      'Cool to the touch (QMax 0.40)',
      'Soft, stretchy knit for the perfect fit',
      'Moisture-wicking & breathable',
      'Machine washable',
    ],
    pairsWith: ['fox', 'otter', 'otter2', 'polarbear'],
  },
  'silk-pillowcase': {
    id: 'silk-pillowcase',
    name: 'Mulberry Silk Luxe Pillowcase',
    price: 89.99,
    url: 'https://lagoonsleep.com/products/100-mulberry-silk-luxe-pillowcase',
    benefits: [
      '100% pure Mulberry silk (22 momme)',
      'Naturally cooling & breathable',
      'Promotes healthy skin & hair',
      'Machine washable',
    ],
    pairsWith: ['chinchilla', 'puffin'],
  },
};

window.suggestComplement = function(pillowId, answers, isAvailable) {
  answers = answers || {};
  const coolingPillows = ['fox', 'otter', 'otter2', 'polarbear'];

  // Goal/temperature OVERRIDES win over the default pillow→case mapping:
  //  • sleeps hot (temp answer OR goal/concern) → always Cooling Flex
  //  • healthier skin & hair goal → always Silk Luxe
  const goals = Array.isArray(answers.goals) ? answers.goals : [];
  const wantsCool = answers.temp === 'hot' || answers.concern === 'hot' || goals.indexOf('hot') !== -1;
  const wantsSkin = goals.indexOf('wrinkles') !== -1 || answers.concern === 'wrinkles';

  let caseId;
  if (wantsSkin)      caseId = 'silk-pillowcase';      // skin & hair beats everything
  else if (wantsCool) caseId = 'cooling-pillowcase';   // hot sleepers → cooling
  else                caseId = coolingPillows.includes(pillowId) ? 'cooling-pillowcase' : 'silk-pillowcase';

  // Out-of-stock fallback: if the mapped case can't be bought, offer the other
  // one rather than an unbuyable bundle. Caller supplies the availability test
  // (live Shopify inventory); with no test supplied, behaviour is unchanged.
  if (typeof isAvailable === 'function' && !isAvailable(caseId)) {
    const other = caseId === 'cooling-pillowcase' ? 'silk-pillowcase' : 'cooling-pillowcase';
    if (isAvailable(other)) caseId = other;
  }

  const pc = window.LAGOON_PILLOWCASES[caseId];

  // Per-pillow "why this case" rationale — references the pillow + benefit.
  const whyMap = {
    'cooling-pillowcase': `Adds a cool-to-the-touch layer over the ${prettyName(pillowId)}'s cooling foam — built for hot sleepers and all positions.`,
    'silk-pillowcase':    `22-momme Mulberry silk pairs with the plush ${prettyName(pillowId)} — naturally cooling and gentle on skin and hair.`,
  };

  return {
    id: pc.id,
    name: pc.name,
    tagline: whyMap[pc.id],
    why: whyMap[pc.id],
    benefits: pc.benefits,
    price: pc.price,
    url: pc.url,
  };
};

function prettyName(id) {
  const p = (window.LAGOON_PILLOWS || []).find(x => x.id === id);
  return p ? p.name : 'pillow';
}

// Reasoning copy fragments by answer — used to assemble "Why this pillow" bullets.
window.LAGOON_REASONS = {
  concern: {
    toss:     'helps quiet tossing and turning',
    neck:     'targets neck & shoulder relief',
    hot:      'has Lagoon\'s strongest cooling',
    snore:    'positions your airway for easier breathing',
    wrinkles: 'low contact reduces face pressure',
    none:     'is our most-loved all-rounder',
  },
  position: {
    side:    'shaped for side sleepers',
    back:    'shaped for back sleepers',
    stomach: 'soft and low — kind to stomach sleepers',
    combo:   'adapts as you switch positions',
  },
  temp: {
    hot:     'sleeps the coolest in our line',
    neutral: 'temperature-neutral fill',
    cold:    'cozy and warmth-retaining',
  },
  body: {
    slender: 'matched to a slender build',
    average: 'sized for an average build',
    broad:   'lifts broad shoulders into alignment',
  },
  density: {
    soft:    'soft, cloud-like feel',
    cushy:   'cushy with gentle cradle',
    firm:    'firm and structured',
    notsure: 'balanced feel most people love',
  },
  height: {
    low:     'low-loft profile',
    medium:  'medium-loft profile',
    high:    'higher-loft profile',
    notsure: 'medium-loft — the safe pick',
  },
};

// ── Fact-checked per-pillow facts ───────────────────────────────────────────
// The single source of truth for "Why this pillow" bullets. Nothing here may
// claim a feature the pillow doesn't actually have — cooling is ONLY asserted
// for otter/otter2 (daily-cool) and polarbear (coldest). Fox/Chinchilla/Puffin are
// temperature-neutral and must NEVER be described as cooling. `fill` is foam
// (memory foam) vs fiber (microfiber) — used so we don't claim foam cradling
// for the microfiber pillows.
window.LAGOON_PILLOW_FACTS = {
  otter:     { cooling: 'cool',    fill: 'foam',  positions: ['side','back','stomach','combo'], feel: 'cushy', loft: 'high'   },
  otter2:    { cooling: 'cool',    fill: 'foam',  positions: ['side','back','stomach','combo'], feel: 'cushy', loft: 'high'   },
  fox:       { cooling: 'neutral', fill: 'foam',  positions: ['side','back','stomach','combo'], feel: 'cushy', loft: 'medium' },
  polarbear: { cooling: 'coldest', fill: 'foam',  positions: ['side'],                          feel: 'firm',  loft: 'high'   },
  chinchilla:{ cooling: 'neutral', fill: 'fiber', positions: ['stomach'],                       feel: 'soft',  loft: 'low'    },
  puffin:    { cooling: 'neutral', fill: 'fiber', positions: ['stomach','back'],                feel: 'soft',  loft: 'low'    },
};

// Build the 3 personalized "why it fits you" bullets shown on the result card.
// Copy is the Lagoon-approved per-pillow matrix. Priority: 1) position fit,
// 2) body/loft (always "...for your <build> build"), 3) feel. Temperature is
// 4th and falls OFF unless the visitor sleeps hot, in which case it promotes
// above feel. Backfill keeps it at exactly 3. Shared by the quiz AND the chat.
window.LAGOON_PILLOW_WHY = function (pillowId, ans) {
  ans = ans || {};
  const pos = ans.position, body = ans.body, feel = ans.density, temp = ans.temp;
  const goals = Array.isArray(ans.goals) ? ans.goals : [];
  const bw = ({ slender: 'slender', average: 'average', broad: 'broad' })[body] || 'unique';
  const hot = temp === 'hot' || ans.concern === 'hot' || goals.indexOf('hot') !== -1;

  // 1) POSITION fit
  function positionLine() {
    switch (pillowId) {
      case 'chinchilla':
        if (pos === 'stomach') return 'Ultra-soft feel is perfect for stomach sleepers';
        if (pos === 'back')    return 'Ultra-soft feel is perfect for back sleepers';
        return 'Perfect malleability for any position you choose';
      case 'puffin':
        if (pos === 'back')    return 'Velvety-soft feel is perfect for back sleepers';
        if (pos === 'stomach') return 'Velvety-soft feel is perfect for stomach sleepers';
        return 'Perfect malleability for any position you choose';
      case 'fox':
      case 'otter':
      case 'otter2':
        if (pos === 'side')    return 'Memory foam & microfiber blend designed for side sleepers';
        if (pos === 'back')    return 'Memory foam & microfiber blend designed for back sleepers';
        if (pos === 'stomach') return 'Memory foam & microfiber blend designed for stomach sleepers';
        return 'Perfect malleability for any position you choose';
      case 'polarbear':
        if (pos === 'back')    return 'Higher loft and reversible sides provide malleability for back sleepers';
        if (pos === 'side')    return 'Higher loft and reversible sides cater to side sleepers';
        return 'Reversible, adjustable design conforms to your sleep position';
    }
    return null;
  }

  // 2) BODY / loft — always ends "...for your <build> build"
  function bodyLine() {
    const suffix = ' for your ' + bw + ' build';
    if (pillowId === 'fox' || pillowId === 'otter' || pillowId === 'otter2') {
      const addFill = body === 'average' || body === 'broad' || pos === 'side';
      return (addFill ? 'Add fill to perfect your alignment'
                      : 'Remove or add back fill to perfect your alignment') + suffix;
    }
    if (pillowId === 'polarbear') return 'Add or remove fill to perfect your alignment' + suffix;
    return 'Remove or add back fill to perfect your alignment' + suffix; // chinchilla, puffin
  }

  // 3) FEEL
  function feelLine() {
    switch (pillowId) {
      case 'chinchilla':
        if (feel === 'soft') return 'Ultra-soft microfibers offer optimal support';
        return 'A softer feel that most stomach sleepers prefer';
      case 'puffin':
        return 'Medium-soft microfibers offer optimal support';
      case 'fox':
        if (feel === 'cushy') return 'Medium-soft feel is the perfect balance of coziness and support';
        if (feel === 'firm')  return 'A balanced, medium-firm feel that most sleepers love';
        return 'A balanced, medium-soft feel that most sleepers love';
      case 'otter':
      case 'otter2':
        if (feel === 'firm') return 'A balanced, medium-firm feel that most sleepers love';
        return 'A balanced, medium-soft feel that most sleepers love';
      case 'polarbear':
        if (feel === 'firm') return 'Firmer feel provides proper support while still being very comfortable';
        return 'A balanced, medium-firm feel that most sleepers love';
    }
    return null;
  }

  // 4) TEMPERATURE — promotes above feel only when hot; cold drops off entirely
  function tempLine() {
    if (temp === 'cold') return null;
    switch (pillowId) {
      case 'otter':
      case 'otter2':    return 'Cool-to-the-touch cover & temperature-regulating fill';
      case 'polarbear': return '4x cooling technologies for optimal temperature regulation';
      case 'fox':
      case 'chinchilla':
      case 'puffin':    return 'Pair the Cooling Flex case for a cool-to-the-touch surface';
    }
    return null;
  }

  const closer = 'Risk-free — backed by 24,000+ Lagoon sleepers and a 100-night trial';
  const pL = positionLine(), bL = bodyLine(), fL = feelLine(), tL = tempLine();

  const ordered = [pL, bL];
  if (hot && tL) { ordered.push(tL); ordered.push(fL); }
  else           { ordered.push(fL); if (tL) ordered.push(tL); }
  ordered.push(closer);

  const seen = {}, out = [];
  for (const x of ordered) {
    if (x && !seen[x]) { seen[x] = 1; out.push(x); }
    if (out.length >= 3) break;
  }
  return out;
};
